import { Button, Form, Skeleton } from "antd";
import { RootState } from "app/store";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import CreationFormItems from "../../../../../components/creation/CreationFormItems";
import { getCreation, putCreation } from "../creationPanelSlice";
import {
  INPUT_MAX_LENGTH,
  URLS,
} from "../../../../../utils-creation/constants";
import {
  Creation,
  CreationInputLength,
  CreationInputLengths,
} from "../../../../../utils-creation/types";
import {
  deserializeData,
  serializeData,
} from "../../../../../utils-creation/utils";

export default function EditCreation() {
  const [inputLengths, setInputLengths] = useState<CreationInputLengths>({
    title: 0,
    url: 0,
    title_in_english: 0,
    media: 0,
    premiere_venue: 0,
    premiere_venue_type: 0,
    premiere_city_country: 0,
    non_premiere_1_venue: 0,
    non_premiere_1_venue_type: 0,
    non_premiere_1_city_country: 0,
    non_premiere_2_venue: 0,
    non_premiere_2_venue_type: 0,
    non_premiere_2_city_country: 0,
    description: 0,
    creator: 0,
    director: 0,
    composer: 0,
    editor: 0,
    curator: 0,
    producer: 0,
    performers: 0,
    writers: 0,
    dramaturg: 0,
    cinematographer: 0,
    director_of_photography: 0,
    technical_director: 0,
    lighting_director: 0,
    set_designer: 0,
    video_production: 0,
    costume_designer: 0,
    installation_designer: 0,
    sound_designer: 0,
    production_designer: 0,
    production_engineer: 0,
    stage_manager: 0,
    distributor: 0,
    additional_credits: 0,
  });
  const [initialInputLengths, setInitialInputLengths] =
    useState<CreationInputLengths>({
      title: 0,
      url: 0,
      title_in_english: 0,
      media: 0,
      premiere_venue: 0,
      premiere_venue_type: 0,
      premiere_city_country: 0,
      non_premiere_1_venue: 0,
      non_premiere_1_venue_type: 0,
      non_premiere_1_city_country: 0,
      non_premiere_2_venue: 0,
      non_premiere_2_venue_type: 0,
      non_premiere_2_city_country: 0,
      description: 0,
      creator: 0,
      director: 0,
      composer: 0,
      editor: 0,
      curator: 0,
      producer: 0,
      performers: 0,
      writers: 0,
      dramaturg: 0,
      cinematographer: 0,
      director_of_photography: 0,
      technical_director: 0,
      lighting_director: 0,
      set_designer: 0,
      video_production: 0,
      costume_designer: 0,
      installation_designer: 0,
      sound_designer: 0,
      production_designer: 0,
      production_engineer: 0,
      stage_manager: 0,
      distributor: 0,
      additional_credits: 0,
    });
  const [initialData, setInitialData] = useState<Creation | null>(null);
  const [isInitialDataLoaded, setIsInitialDataLoaded] = useState(false);
  let { id } = useParams<{ id: any }>();
  id = Number(id);
  const history = useHistory();
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const { user } = useSelector((state: RootState) => state.authentication);

  const { creationToEdit } = useSelector(
    (state: RootState) => state.creationPanel
  );

  useEffect(() => {
    dispatch(getCreation(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (creationToEdit && user) {
      const newData: Creation = deserializeData(creationToEdit, user.id);
      setInitialData(newData);
      Object.keys(INPUT_MAX_LENGTH).forEach((key: string) => {
        setInitialInputLengths((prevInputLengths: CreationInputLengths) => ({
          ...prevInputLengths,
          [key]: (newData[key as CreationInputLength] as string)?.length || 0,
        }));
        setInputLengths((prevInputLengths: CreationInputLengths) => ({
          ...prevInputLengths,
          [key]: (newData[key as CreationInputLength] as string)?.length || 0,
        }));
      });
      form.setFieldsValue(newData);
      setIsInitialDataLoaded(true);
    }
  }, [creationToEdit, form, user]);

  const onFinish = (values: Creation) => {
    serializeData(values);
    values.id = id;
    dispatch(
      putCreation({
        payload: values,
        callback: redirectToCreationPage,
      })
    );
  };

  const handleReset = () => {
    if (initialData) {
      form.setFieldsValue(initialData);
      setInputLengths(initialInputLengths);
      window.scrollTo(0, 0);
    }
  };

  const onValuesChange = (changedValues: any, allValues: any) => {
    const key = Object.keys(changedValues)[0];
    if (typeof changedValues[key] === "string")
      setInputLengths((prevInputLengths: CreationInputLengths) => ({
        ...prevInputLengths,
        [key]: changedValues[key].length,
      }));
  };

  const redirectToCreationPage = () => {
    user !== null && history.push(URLS.RESEARCH_CREATION_ROOT);
  };

  if (!isInitialDataLoaded) return <Skeleton active />;

  return (
    <Form
      className="sub-heading-font add-creation"
      labelCol={{
        xs: { span: 24 },
        sm: { span: 24 },
        md: { span: 5 },
        lg: { span: 4 },
      }}
      wrapperCol={{
        xs: { span: 24 },
        sm: { span: 24 },
        md: { span: 16 },
        lg: { span: 17 },
      }}
      form={form}
      onFinish={onFinish}
      onValuesChange={onValuesChange}
      scrollToFirstError={{ behavior: "smooth" }}
    >
      <CreationFormItems inputLengths={inputLengths} formType="EDIT" />

      <Form.Item wrapperCol={{ offset: 8, span: 8 }}>
        <Button
          type="primary"
          htmlType="submit"
          style={{ marginRight: "16px" }}
        >
          UPDATE
        </Button>
        <Button
          htmlType="button"
          style={{ marginRight: "16px" }}
          onClick={handleReset}
        >
          RESET
        </Button>
        <Button htmlType="button" onClick={redirectToCreationPage}>
          CANCEL
        </Button>
      </Form.Item>
    </Form>
  );
}
